import React, { useState } from "react";
import { Header } from "../../components/Header/Header";
import { Footer } from "../../components/Footer/Footer";

/*
  PageTemplate wraps Header and Footer
  It has as props: 
  - customClasses as aditional classes for the div
  - headerCustomClasses for the Header component, 
  - footerCustomClasses for the Foter component,
  - modal to add or remove the Modal component based on boolean values, trigger throught mouseleave event
  - children as page's content.
*/

export const PageTemplate = ({
  customClasses,
  headerCustomClasses,
  footerCustomClasses,
  children,
}) => {
  const [setIsModalActive] = useState(false);

  const _customClasses = customClasses && customClasses;
  const _footerCustomClasses = footerCustomClasses && footerCustomClasses;

  function handleOpenModalOnLeave(event) {
    event.preventDefault();

    // if (process.env.NODE_ENV === "development") {
    //   setIsModalActive(false);
    // } else {
    //   if ("1" != sessionStorage.getItem("hideModal")) {
    //     setIsModalActive(true);
    //   }
    // }
  }

  return (
    <div
      className={["container-page", _customClasses].join(" ")}
      onMouseLeave={(event) => handleOpenModalOnLeave(event)}
    >
      <Header
        customClasses={headerCustomClasses}
        iconNameLeft="arrow-left"
        iconNameRight=""
      />
      {children}

      <Footer customClasses={_footerCustomClasses} />
    </div>
  );
};
